<template>
  <v-dialog v-model="$store.state.mudarSenha" max-width="500" persistent>
    <v-card>
      <v-card-title class="headline info white--text">
        <v-icon left color="white">mdi-lock-reset</v-icon>
        Alteração de Senha
      </v-card-title>

      <v-card-text class="mt-4">
        <v-form ref="form" @submit.prevent="submit">
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="senhaAtual"
                :rules="[rules.required]"
                :append-icon="showSenhaAtual ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showSenhaAtual ? 'text' : 'password'"
                label="Senha atual"
                outlined
                prepend-icon="mdi-lock"
                @click:append="showSenhaAtual = !showSenhaAtual"
                required
              ></v-text-field>
              <v-alert v-if="senhaAtualIncorreta" type="error" dense text>
                Senha incorreta
              </v-alert>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="novaSenha"
                :rules="[rules.required, rules.min, rules.complexidade]"
                :append-icon="showNovaSenha ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showNovaSenha ? 'text' : 'password'"
                label="Nova senha"
                outlined
                prepend-icon="mdi-lock-plus"
                @click:append="showNovaSenha = !showNovaSenha"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="confirmarSenha"
                :rules="[rules.required, rules.confirm]"
                :append-icon="showConfirmarSenha ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showConfirmarSenha ? 'text' : 'password'"
                label="Confirmar nova senha"
                outlined
                prepend-icon="mdi-lock-check"
                @click:append="showConfirmarSenha = !showConfirmarSenha"
                required
              ></v-text-field>
              <v-alert v-if="ShowsenhasNaoCoincidem" type="error" dense text>
                As senhas não coincidem
              </v-alert>
            </v-col>
          </v-row>

          <v-alert v-if="mensagemSucesso" type="success" dense>
            Senha alterada com sucesso!
          </v-alert>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click="submit"
          :disabled="!formValido"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')

export default {
  name: 'ActualizarSenha',

  data: () => ({
    senhaAtual: '',
    novaSenha: '',
    confirmarSenha: '',
    showSenhaAtual: false,
    showNovaSenha: false,
    showConfirmarSenha: false,
    senhaAtualIncorreta: false,
    senhasNaoCoincidem: false,
    mensagemSucesso: false,
    loading: false,

    rules: {
      required: value => !!value || 'Campo obrigatório',
      min: value => value.length >= 8 || 'Mínimo de 8 caracteres',
      complexidade: value => {
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/
        return pattern.test(value) || 'Deve conter minúscula, maiúscula e número'
      },
    }
  }),

  computed: {
    formValido () {
      return (
        this.senhaAtual &&
        this.novaSenha &&
        this.confirmarSenha &&
        this.novaSenha === this.confirmarSenha
      )
    },

    ShowsenhasNaoCoincidem(){
        return (this.novaSenha !== '' && this.confirmarSenha !== '') && this.novaSenha !== this.confirmarSenha
    }
  },

  methods: {
    async submit () {
      if (!this.$refs.form.validate()) return

      this.loading = true
      this.senhaAtualIncorreta = false
      this.senhasNaoCoincidem = false

      try {
        // 1. Verificar senha atual
        const verifica = await axios.post('/Verifica-senha/', {
          password: this.senhaAtual
        })
        

        if (!verifica.data.length) {
          this.senhaAtualIncorreta = true
          this.loading = false
          return
        }

        // 2. Verificar se nova senha e confirmação coincidem
        if (this.novaSenha !== this.confirmarSenha) {
          this.senhasNaoCoincidem = true
          this.loading = false
          return
        }

        // 3. Atualizar senha
        await axios.post('/altera-senha/', {
          password: this.novaSenha
        })

        this.mensagemSucesso = true
        this.clear()

       

        

      } catch (error) {
        console.error('Erro ao atualizar senha:', error)
      } finally {
        this.loading = false
      }
    },

    clear () {
      this.$refs.form.reset()
      this.senhaAtual = ''
      this.novaSenha = ''
      this.confirmarSenha = ''
      this.senhaAtualIncorreta = false
      this.senhasNaoCoincidem = false

       setTimeout(() => {
            this.$store.dispatch('toggleMudarSenha', false); // abrir   
            this.logout()
        }, 1000);
    },

    close(){
      this.$refs.form.reset()
      this.senhaAtual = ''
      this.novaSenha = ''
      this.confirmarSenha = ''
      this.senhaAtualIncorreta = false
      this.senhasNaoCoincidem = false
        this.$store.dispatch('toggleMudarSenha', false); // abrir   
    },

    logout () {
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    }
  }
}
</script>
